import { ExclamationGrayIcon } from '../../../icons/SvgIcons';
import { PrimaryButton } from '../Button/Buttons';

type UnableToLoadContentProps = {
  onRetry: () => void;
  title?: string;
  description?: string;
  buttonText?: string;
  className?: string;
};

export function UnableToLoadContent({
  onRetry,
  title = 'Unable to load content',
  description = 'We encountered an issue while retrieving this information. Please try loading it again.',
  buttonText = 'Try Again',
  className = ''
}: UnableToLoadContentProps) {
  return (
    <div
      className={`h-full flex flex-col items-center justify-center ${className}`}
    >
      {ExclamationGrayIcon()}
      <p className="text-gray-900 text-sm font-medium mb-1 mt-2">{title}</p>
      <p className="text-gray-500 text-sm mb-6 text-center">{description}</p>
      <PrimaryButton onClick={onRetry}>{buttonText}</PrimaryButton>
    </div>
  );
}
